import React, { useState, useEffect, useRef, useCallback } from 'react';
import './Main.css';

import image1 from '../asset/left_aboutMe.png';
import image2 from '../asset/top_contact.png';
import image3 from '../asset/bottom_links.svg';
import image4 from '../asset/right_works.png';

import imageColor1 from '../asset/left_aboutMe_color.svg';
import imageColor2 from '../asset/top_contact_color.svg';
import imageColor3 from '../asset/bottom_links_color.svg';
import imageColor4 from '../asset/right_works_color.svg';

import imageShadow from '../asset/shadow.png';

import usbImage from '../asset/usb.svg';
import usbHubImage from '../asset/usb_hub.svg';

import pc from '../asset/pc.svg';
import dragAndDrop from '../asset/drag_and_drop.svg';
import saturn from '../asset/saturn_1.svg';
import satellite from '../asset/satellite.svg';
import constellation1 from '../asset/constellation1.svg';
import constellation2 from '../asset/constellation2.svg';

const randomSentences = [
    "We are merely reactive beings; the self is an illusion, and only feelings are real.",
    "Even so, we must love, for what reaches you is what keeps me alive.",
    "I love the universe. Only its vastness brings me comfort.",
    "I seek only emptiness, yet what I desire is fullness.",
    "I want to feel safe, and that’s why I long for the desert.",
    "My attempts to reach those places were clumsy, but my wandering was beautiful.",
    "Why is it that I cannot reach the beauties I seek?",
    "I will reach them. For the moment of becoming one, I will be sincere in every moment.",
    "Our beauty will shine in the desert and in the universe.",
    "oh, your beauty, oh, my journey."
];

function Main({
    isImageClicked, handleMenuClick, currentMenu, 
    usbPosition, setUsbPosition, 
    setShowBlueScreen, 
    setShowAboutMeModal, setShowWorksModal, setShowLinksModal, setShowContactModal, setShowLinksAndContactModal,
    isDragging, setIsDragging, animationComplete, setAnimationComplete, showDragAndDropImage, setShowDragAndDropImage
}) {
    const [hoveredImage, setHoveredImage] = useState(null);
    const [moveX, setMoveX] = useState(0);
    const [moveY, setMoveY] = useState(0);
    const [backgroundMoveX3, setBackgroundMoveX3] = useState(0);
    const [backgroundMoveY3, setBackgroundMoveY3] = useState(0);
    const [saturnMoveX, setSaturnMoveX] = useState(0);
    const [saturnMoveY, setSaturnMoveY] = useState(0);
    const [satelliteMoveX, setSatelliteMoveX] = useState(0);
    const [satelliteMoveY, setSatelliteMoveY] = useState(0);

    const isDraggingRef = useRef(isDragging);

    useEffect(() => {
        isDraggingRef.current = isDragging;
    }, [isDragging]);

    useEffect(() => {
        window.scrollTo({
            top: window.innerHeight,
            behavior: 'smooth'
        });
    
        const handleMouseMove = (e) => {
            const windowWidth = window.innerWidth;
            const windowHeight = window.innerHeight;
            const mouseX = e.clientX - windowWidth / 2;
            const mouseY = e.clientY - windowHeight / 2;
        
            setBackgroundMoveX3(-(mouseX / windowWidth) * 100);
            setBackgroundMoveY3(-(mouseY / windowHeight) * 100);
        
            setSaturnMoveX((mouseX / windowWidth) * 80);
            setSaturnMoveY(-(mouseY / windowHeight) * 60);
        
            setSatelliteMoveX(-(mouseX / windowWidth) * 110);
            setSatelliteMoveY((mouseY / windowHeight) * 70);
        
            setMoveX(-(mouseX / windowWidth) * 60);
    
            if (mouseY < 0) {
                setMoveY(-(mouseY / windowHeight) * 60);
            } else {
                setMoveY(0);
            }
        
            if (mouseY < 0) {
                setBackgroundMoveY3(-(mouseY / windowHeight) * 100); // 위로만 이동 가능
            } else {
                setBackgroundMoveY3(0); // 아래로 이동할 때 고정
            }
        };
    
        window.addEventListener('mousemove', handleMouseMove);
    
        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
        };
    }, []);
    
    const handleMouseEnter = (image) => {
        setHoveredImage(image);
    };

    const handleMouseLeave = () => {
        setHoveredImage(null);
    };

    const handleMouseMoveDrag = useCallback(() => {
        if (isDraggingRef.current) {
            const width = window.innerWidth;
            const height = window.innerHeight;
            const aspectRatio = width / height;  // 가로 세로 비율 계산
    
            // 기준 비율에 따른 vh 값 설정
            const ratio1 = 1.983; // 기준 비율 1
            const vh1 = 67.2; // 기준 vh 값 1
            const ratio2 = 1.875; // 기준 비율 2
            const vh2 = 68.5; // 기준 vh 값 2
    
            // 비율 2.5 ~ 1.5 사이의 선형 보간법을 이용해 vh 값 계산
            let vh = vh1 + (vh2 - vh1) * ((aspectRatio - ratio1) / (ratio2 - ratio1));
    
            setUsbPosition(vh);
    
            setTimeout(() => {
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth',
                });
            }, 800);
        }
    }, [setUsbPosition]);

    const handleMouseDown = (e) => {
        e.preventDefault();
        setIsDragging(true);
    };

    const handleMouseUp = useCallback(() => {
        setIsDragging(false);
    }, [setIsDragging]);
    
    const handleAnimationEnd = () => {
        setAnimationComplete(true);

        if (isImageClicked) {
            setShowDragAndDropImage(true);
        } else {
            setShowDragAndDropImage(false);
        }
    };
    
    useEffect(() => {
        if (isDragging) {
            window.addEventListener('mousemove', handleMouseMoveDrag);
            window.addEventListener('mouseup', handleMouseUp);
        } else {
            window.removeEventListener('mousemove', handleMouseMoveDrag);
            window.removeEventListener('mouseup', handleMouseUp);
        }
    
        return () => {
            window.removeEventListener('mousemove', handleMouseMoveDrag);
            window.removeEventListener('mouseup', handleMouseUp);
        };
    }, [isDragging, handleMouseMoveDrag, handleMouseUp]);
    
    const [sentences, setSentences] = useState([]);
    
    useEffect(() => {
        const selectedSentences = randomSentences.slice(0, 10);
        setSentences(selectedSentences);
    }, []);

    const handlePcClick = (currentMenu) => {
        setShowBlueScreen(true);
    
        if (currentMenu === "aboutMe") {
            setTimeout(() => {
                setShowAboutMeModal(true);
            }, 1000);
        } else if (currentMenu === "works") {
            setTimeout(() => {
                setShowWorksModal(true);
            }, 1000);
        } else if (currentMenu === "links") {
            setTimeout(() => {
                setShowLinksModal(true);
            }, 1000);
        } else if (currentMenu === "contact") {
            setTimeout(() => {
                setShowContactModal(true);
            }, 1000);
        } else if (currentMenu === "linksAndContact") {
            setTimeout(() => {
                setShowLinksAndContactModal(true);
            }, 1000);
        }
    };

    return (
        <div>
            <div className="sentence-container3">
                {sentences.map((sentence, index) => (
                <div
                    key={index}
                    className="sentence3"
                    style={{ 
                    top: `${index * 3}vh`,
                    '--index': index,
                    '--animation-delay': `${index}s`, 
                    '--animation-duration': `${200}s`
                    }}
                >
                    {Array(50).fill(sentence).join('◻️◻️◻️■◻■')}
                </div>
                ))}
            </div>
            <div className="sentence-container1">
                {sentences.map((sentence, index) => (
                <div
                    key={index}
                    className="sentence1"
                    style={{ 
                    top: `${index * 2}vh`,
                    '--index': index,
                    '--animation-delay': `${index}s`, 
                    '--animation-duration': `${150}s`
                    }}
                >
                    {Array(50).fill(sentence).join('◻️◻️◻️■◻■')}
                </div>
                ))}
            </div>
            <div className="sentence-container2">
                {sentences.map((sentence, index) => (
                <div
                    key={index}
                    className="sentence2"
                    style={{ 
                    top: `${index * 1}vh`,
                    '--index': index,
                    '--animation-delay': `${index}s`, 
                    '--animation-duration': `${300}s`
                    }}
                >
                    {Array(50).fill(sentence).join('◻️◻️◻️■◻■')}
                </div>
                ))}
            </div>

            <img
                src={constellation1}
                alt="Constellation1"
                className="fullscreen-image constellation1"
                style={{
                    width: "20vw",
                    height: "auto",
                    left: '5vw',
                    bottom: '60vh',
                    // position: "absolute"
                }}
            />
            <img
                src={constellation2}
                alt="Constellation2"
                className="fullscreen-image constellation2"
                style={{
                    width: "17vw",
                    height: "auto",
                    left: '82vw',
                    bottom: '47vh',
                    // position: "absolute"
                }}
            />
            <img
                src={saturn}
                alt="Saturn"
                className="fullscreen-image"
                style={{
                    width: '20vw',
                    height: 'auto',
                    left: '10vw',
                    bottom: '54vh',
                    // position: 'absolute',
                    transform: `translate(${saturnMoveX}px, ${saturnMoveY}px)`
                }}
            />
            <img
                src={satellite}
                alt="Satellite"
                className="fullscreen-image"
                style={{
                    width: '12vw',
                    height: 'auto',
                    left: '80vw',
                    bottom: '70vh',
                    // position: 'absolute',
                    transform: `translate(${satelliteMoveX}px, ${satelliteMoveY}px)`
                }}
            />

            <img
                src={imageShadow}
                alt="Shadow"
                className="fullscreen-image"
                style={{
                    width: 'auto',
                    height: '77vh',
                    position: 'absolute',
                    opacity: '0.8',
                    left: '50%',
                    bottom: '0',
                    transform: `translateX(-50%) translate(${backgroundMoveX3}px, ${backgroundMoveY3}px)`,
                    zIndex: 2
                }}
            />

            <div className="main-screen">
                <div
                    className={`container ${hoveredImage ? `move-${hoveredImage}` : ''}`}
                    style={{ transform: `translate(${moveX}px, ${moveY}px)` }}
                >
                    <div className="left-image" onClick={() => handleMenuClick("aboutMe")}>
                        <img
                            src={hoveredImage === 'left' ? imageColor1 : image1}
                            alt=""
                        />
                        <div
                            className="click-area left"
                            onMouseEnter={() => handleMouseEnter('left')}
                            onMouseLeave={handleMouseLeave}
                        ></div>
                    </div>

                    {isImageClicked && (
                        <img
                            src={usbImage}
                            alt=""
                            className={`hidden-usb-image ${animationComplete ? 'no-animation' : 'animate'}`}
                            style={{ bottom: `${usbPosition}vh` }}
                            onMouseDown={handleMouseDown}
                            onAnimationEnd={handleAnimationEnd}
                        />
                    )}
                    {showDragAndDropImage && (
                        <img
                            src={dragAndDrop}
                            alt=""
                            className="drag-and-drop-image"
                        />
                    )}

                    <div className={'usb-hub-image'}>
                        <img
                            src={usbHubImage}
                            alt=""
                        />
                    </div>

                    <div className={'pc'} onClick={() => handlePcClick(currentMenu)}>
                        <img
                            src={pc}
                            alt=""
                        />
                    </div>

                    <div className="center-images">
                        <img
                            src={hoveredImage === 'up' ? imageColor2 : image2}
                            alt=""
                        />
                        <div
                            className="click-area center-top"
                            onClick={() => handleMenuClick("linksAndContact")}
                            onMouseEnter={() => handleMouseEnter('up')}
                            onMouseLeave={handleMouseLeave}
                        ></div>
                        <img
                            src={hoveredImage === 'down' ? imageColor3 : image3}
                            alt=""
                        />
                        <div
                            className="click-area center-bottom"
                            onClick={() => handleMenuClick("linksAndContact")}
                            onMouseEnter={() => handleMouseEnter('down')}
                            onMouseLeave={handleMouseLeave}
                        ></div>
                    </div>

                    <div className="right-image">
                        <img
                            src={hoveredImage === 'right' ? imageColor4 : image4}
                            alt=""
                        />
                        <div
                            className="click-area right"
                            onClick={() => handleMenuClick("works")}
                            onMouseEnter={() => handleMouseEnter('right')}
                            onMouseLeave={handleMouseLeave}
                        ></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Main;